module.exports = __webpack_public_path__ + "static/media/4.55c17eb8.jpeg";